import Result from './result';

export default Result;
